import './anims-on-scroll.js';
import './glightbox.js';
import './nav-mobile.js';
import './nav-transparent.js';
import './swiper.init.js';
import './tailwind.config.js';

// import '../css/input.css';